import {
  useAgregarLlamadaMutation,
  useGetTipoSeguroQuery,
} from "../../../services/docs";
import { useForm } from "../../../hooks/useForm";
import { useNavigate } from "react-router-dom";
import { Label } from "../../../components/ui/Label";
import { Input, InputBaseClassName } from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BuscarPolizaComponent } from "../../../components/BuscarPolizaComponent";
import { Spinner } from "../../../components/Spinner";
import {
  agregarLlamadaID,
  agregarSeleccion,
} from "../../../features/ui/uiSlice";
import { encode } from "../../../hooks/code";
import { BuscarPolizaForm } from "../../../components/BuscarPolizaForm";
import { InputField } from "../../../components/ui/InputField";
import { Eye, EyeClosed, Icon, Phone, User } from "lucide-react";
import { Boton } from "../../../components/ui/Boton";
import { EyeSlash } from "@phosphor-icons/react";

const vacio = {
  fc_telefono: "",
  fi_tipo_seguro: "",
  fi_tipo_llamada: "",
  fi_sub_llamada: "",
  fc_nombre_completo: "",
  fc_comentarios: "",
  fi_medio_contratacion: "",
};

export const InbountScreen = () => {
  const { data, isLoading: cargando } = useGetTipoSeguroQuery();
  const [isBusqueda, setIsBusqueda] = useState(false);
  const [isTipoLlamada, setIsTipoLlamada] = useState(false);
  const [tipoSeguro, setTipoSeguro] = useState("");
  const [tipoLlamada, setTipoLlamada] = useState([]);
  const [subLlamada, setSubLlamada] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    formulario,
    handleInputChange,
    handleSelectChange,
    handleTexareChange,
    reset,
  } = useForm(vacio);
  useEffect(() => {
    if (formulario.fi_tipo_seguro !== "") {
      if (data.tipo_seguro.length > 0) {
        const seleccionado = data.tipo_seguro.filter(
          (t: any) => t.id === +formulario.fi_tipo_seguro
        );
        if (seleccionado.length > 0) {
          setTipoSeguro(seleccionado[0].fc_tipo_base);
          if (seleccionado[0].fi_busqueda === 1) {
            setIsBusqueda(true);
          } else {
            setIsBusqueda(false);
          }
          console.log(seleccionado[0].fi_tipo_llamada);

          setIsTipoLlamada(seleccionado[0].fi_tipo_llamada);
        }
      }
    } else {
      setIsBusqueda(false);
      setIsTipoLlamada(false);
      setTipoLlamada([]);
    }
  }, [formulario.fi_tipo_seguro]);
  useEffect(() => {
    if (isTipoLlamada) {
      const tipoLlamada = data.tipo_llamada.filter(
        (ll: any) => ll.tipo_seguro_id === +formulario.fi_tipo_seguro
      );
      setTipoLlamada(tipoLlamada);
    }
  }, [isTipoLlamada, formulario.fi_tipo_seguro]);
  useEffect(() => {
    if (+formulario.fi_tipo_seguro > 0) {
      const subLlamada = data.sub_llamada.filter(
        (sub) => sub.tipo_llamada_id === +formulario.fi_tipo_llamada
      );
      setSubLlamada(subLlamada);
    }
  }, [formulario.fi_tipo_llamada]);

  const vermas = (ll: any) => {
    dispatch(agregarLlamadaID({ fi_llamada_id: ll.id }));
    let info = {
      fi_llamada_id: ll.id,
      tipo: ll.tipo_seguro,
      id: ll.ATMID,
    };
    let cod = encode(info);
    dispatch(agregarSeleccion(cod));
    navigate(`/home/ver/informacion`);
  };
  const [agregarLlamadaAction, { data: pol, isLoading, error }] =
    useAgregarLlamadaMutation();
  const GuardarLlamada = async () => {
    if (formulario.fc_telefono.trim() === "") {
      toastr.error("Debe de agregar Teléfono");
      return;
    }
    if (formulario.fi_tipo_seguro === "") {
      toastr.error("Debe de seleccionar  Tipo de seguro");
      return;
    }
    if (formulario.fi_tipo_llamada === "") {
      toastr.error("Debe de seleccionar  Tipo de Llamada");
      return;
    }
    if (formulario.fi_medio_contratacion === "") {
      toastr.error("Debe de seleccionar un medio de contratación");
      return;
    }
    if (formulario.fc_nombre_completo === "") {
      toastr.error("Debe de agregar  Nombre Completo");
      return;
    }
    if (formulario.fc_comentarios === "") {
      toastr.error("Debe de agregar un comentario");
      return;
    }

    const ll = await agregarLlamadaAction({
      ...formulario,
      fi_tipo_seguro: +formulario.fi_tipo_seguro,
      fi_tipo_llamada: +formulario.fi_tipo_llamada,
      fi_medio_contratacion: +formulario.fi_medio_contratacion,
      fi_sub_llamada:
        formulario.fi_sub_llamada !== "" ? +formulario.fi_sub_llamada : 0,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
        toastr.error(err.message);
        return;
      });
    if (ll.status) {
      toastr.info(ll.message);
      reset(vacio);
    } else {
      toastr.error(ll.message);
    }
  };
  return (
    <>
      <div className="grid place-items-stretch gap-4 sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-2">
        {cargando && (
          <div className="flex flex-col items-center">
            <Spinner />
          </div>
        )}
        {data &&
          data.llamadas_pendientes &&
          data.llamadas_pendientes.length > 0 && (
            <div className="overflow-hidden rounded-2xl border border-slate-100 bg-[#faf9f9] p-6 shadow-sm">
              <div className="my-6 flex items-center gap-3 border-l-4 border-metric-blue-700 pl-4">
                <h2 className=" font-manrope text-lg font-bold text-slate-900">
                  Pendientes por calificar
                </h2>
              </div>
              <div className="max-h-96 overflow-y-auto rounded-lg border border-gray-200 shadow-md">
                <table className="w-full border-collapse items-center overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
                  <thead className="">
                    <tr className="">
                      <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                        Asegurado
                      </th>
                      <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                        Teléfono
                      </th>
                      <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                        Registro
                      </th>
                      <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                        Ver
                      </th>
                    </tr>
                  </thead>
                  <tbody className="dark:divide-gray-199 divide-y divide-gray-200">
                    {data.llamadas_pendientes.map((ll: any) => {
                      return (
                        <tr
                          key={ll.id}
                          className="border-b-secondary-ultra-light"
                        >
                          <td className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs">
                            {ll.fc_nombre_completo}
                          </td>
                          <td className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs">
                            {ll.fc_telefono}
                          </td>
                          <td className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs">
                            {ll.fd_registro}
                          </td>
                          <td className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs">
                            <Button
                              className="rounded-2xl"
                              onClick={() => {
                                vermas(ll);
                              }}
                            >
                              <Eye />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        <div className="flex flex-col gap-6 rounded-2xl border border-slate-100 bg-white p-8 shadow-sm">
          <div className="flex items-center gap-3 border-l-4 border-metric-blue-700 pl-4">
            <h2 className="font-manrope text-lg font-bold text-slate-900">
              Registrar Llamada
            </h2>
          </div>
          <div className="grid grid-cols-1 place-items-stretch gap-4">
            <div className="grid grid-cols-2 gap-6">
              <InputField
                value={formulario.fc_telefono}
                onChange={handleInputChange}
                name="fc_telefono"
                label="Teléfono:"
                placeholder=""
                icon={Phone}
              />

              <div className="flex w-full flex-col gap-1.5">
                <Label
                  htmlFor="fi_tipo_poliza"
                  className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                >
                  Tipo de Seguro:
                </Label>
                <select
                  className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                  name="fi_tipo_seguro"
                  onChange={handleSelectChange}
                  value={formulario.fi_tipo_seguro}
                >
                  <option value="">Selecciona un tipo de seguro</option>
                  {data &&
                    data.tipo_seguro.length > 0 &&
                    data.tipo_seguro.map((t: any) => {
                      return (
                        <option key={t.id} value={t.id}>
                          {t.fc_tipo_seguro}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            {isTipoLlamada && (
              <div className="grid grid-cols-2 gap-6">
                <div className="flex w-full flex-col gap-1.5">
                  <Label
                    htmlFor="fi_tipo_llamada"
                    className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                  >
                    Tipo de Llamada:
                  </Label>
                  <select
                    className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                    name="fi_tipo_llamada"
                    onChange={handleSelectChange}
                    value={formulario.fi_tipo_llamada}
                  >
                    <option value="">Selecciona un tipo de llamada</option>
                    {tipoLlamada.length > 0 &&
                      tipoLlamada.map((t: any) => {
                        return (
                          <option key={t.id} value={t.idTipoLlamada}>
                            {t.descTipoLlamada}
                          </option>
                        );
                      })}
                  </select>
                </div>

                {subLlamada.length > 0 && (
                  <div className="flex w-full flex-col gap-1.5">
                    <Label
                      htmlFor="fi_sub_llamada"
                      className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                    >
                      Sub Tipo de Llamada:
                    </Label>
                    <select
                      className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                      name="fi_sub_llamada"
                      onChange={handleSelectChange}
                      value={formulario.fi_sub_llamada}
                    >
                      <option value="">Selecciona un Sub Tipo</option>
                      {subLlamada.length > 0 &&
                        subLlamada.map((t: any) => {
                          return (
                            <option key={t.id} value={t.id}>
                              {t.fc_sub_llamada}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                )}

                <div className="flex w-full flex-col gap-1.5">
                  <Label
                    htmlFor="fi_medio_contratacion"
                    className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                  >
                    Medio de contratación:
                  </Label>
                  <select
                    className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                    name="fi_medio_contratacion"
                    onChange={handleSelectChange}
                    value={formulario.fi_medio_contratacion}
                  >
                    <option value="">
                      Selecciona un medio de contratación
                    </option>
                    {data &&
                      data.medio_contratacion.length > 0 &&
                      data.medio_contratacion.map((t: any) => {
                        return (
                          <option key={t.id} value={t.id}>
                            {t.fc_medio_contratacion}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
            )}
            <div className="flex w-full flex-col gap-1.5">
              <InputField
                value={formulario.fc_nombre_completo}
                onChange={handleInputChange}
                name="fc_nombre_completo"
                label="Nombre Completo:"
                placeholder=""
                icon={User}
              />
            </div>
            <div className="flex w-full flex-col gap-1.5">
              <Label
                htmlFor="fc_comentarios"
                className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
              >
                Comentario:
              </Label>
              <textarea
                className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                name="fc_comentarios"
                value={formulario.fc_comentarios}
                onChange={handleTexareChange}
                rows={3}
                cols={4}
              />
            </div>
            {!isBusqueda && (
              <div>
                {!isLoading && (
                  <div className="mt-6 flex flex-col px-6 py-2">
                    <Boton icon={Phone} onClick={GuardarLlamada}>
                      Guardar Llamada
                    </Boton>
                  </div>
                )}
                {isLoading && (
                  <div className="my-6 flex flex-col items-center">
                    <Spinner />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {isBusqueda && (
          <BuscarPolizaComponent
            fc_telefono={formulario.fc_telefono}
            fi_tipo_seguro={formulario.fi_tipo_seguro}
            fc_tipo_base={tipoSeguro}
          />
        )}
      </div>
    </>
  );
};
